import React, { useState, useEffect } from "react";
import { useAuth } from "../components/auth/authContext";
import { useTranslation } from "react-i18next";
import { requestAuthGet } from "../api/authInstance";
import _ from "lodash";
import CardOutlet from "../components/Card/CardOutlet";
import ModalOutlet from "../components/Modal/ModalOutlet";
import Header from "../components/Header";
import Container from "../components/Container/Container";

const OutletManagement = () => {
  const { userData } = useAuth();
  const { t } = useTranslation();

  const [outlets, setOutlets] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showModalOutlet, setShowModalOutlet] = useState(false);
  const [inputOutlet, setInputOutlet] = useState({});
  const [modalOutletDetails, setModalOutletDetails] = useState({
    title: "Add Outlet",
    type: "Add",
  });
  function ShowEditModalOutlet(data) {
    setInputOutlet(data);
    setShowModalOutlet(true);
    setModalOutletDetails({
      title: "Edit Outlet",
      type: "Edit",
    });
  }

  const GetOutlet = async () => {
    try {
      setIsLoading(true);
      const { data } = await requestAuthGet("outlets", {
        params: {
          retailer: userData?.outlet?.retailer?.id,
          limit: 10000,
        },
      });
      setOutlets(data.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error ewallet transactions data:", error);
    }
  };

  useEffect(() => {
    userData && GetOutlet();
  }, [userData]);

  return (
    <>
      <Header
        title="Manajemen Toko"
        rightButton={(e) => {
          e.preventDefault();
          e.stopPropagation();
          // setData({});
          // setType("add");
          // setShowModalUser(true);
        }}
        rightButtonIcon={
          <svg
            className="h-4 w-4 flex-shrink-0 fill-current"
            viewBox="0 0 16 16"
          >
            <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
          </svg>
        }
      />
      <div className="min-h-screen bg-monochrome-25 px-4 py-20">
        {/* <div className="flex items-center justify-between">
          <h2 className="font-medium text-gray-700">Outlet</h2>
        </div> */}
        <Container>
          <div className="mt-4 max-h-dvh overflow-y-scroll">
            <div className="space-y-3">
              {_.isEmpty(outlets) ? (
                <div className="h-28 w-full border-2 border-dashed">
                  <div className="flex h-full w-full items-center justify-center space-x-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="h-5 w-5 text-gray-400"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M13.5 21v-7.5a.75.75 0 01.75-.75h3a.75.75 0 01.75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349m-16.5 11.65V9.35m0 0a3.001 3.001 0 003.75-.615A2.993 2.993 0 009.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 002.25 1.016c.896 0 1.7-.393 2.25-1.016a3.001 3.001 0 003.75.614m-16.5 0a3.004 3.004 0 01-.621-4.72L4.318 3.44A1.5 1.5 0 015.378 3h13.243a1.5 1.5 0 011.06.44l1.19 1.189a3 3 0 01-.621 4.72m-13.5 8.65h3.75a.75.75 0 00.75-.75V13.5a.75.75 0 00-.75-.75H6.75a.75.75 0 00-.75.75v3.75c0 .415.336.75.75.75z"
                      />
                    </svg>
                    <span className="text-sm text-gray-400">
                      {isLoading ? "Loading..." : t("profile.emptyOutlet")}
                    </span>
                  </div>
                </div>
              ) : (
                outlets.map((outlet, index) => (
                  <CardOutlet
                    key={index}
                    data={outlet}
                    enActionEdit={true}
                    isDisable={true}
                    editFunction={ShowEditModalOutlet}
                  />
                ))
              )}
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default OutletManagement;
